import { Link } from "react-router-dom";
import { useLang } from "@/App";
import { all, pick } from "@/data/images";
import Hero from "@/components/Hero";
import Foto from "@/components/Foto";
import { Reveal, Pretitulo, TituloSeccion } from "@/components/Reveal";

export default function Fotos() {
  const { t } = useLang();
  const p = t.fotos;

  return (
    <div data-testid="pagina-fotos">
      <Hero pre={p.hero.pre} titulo={p.hero.titulo} fotos={[pick(p.hero.foto[0], 0) || all(p.hero.foto[0])[0]]} testid="hero-fotos" />

      <section className="py-20 md:py-28" data-testid="f-presentacion">
        <div className="mx-auto max-w-3xl px-6 md:px-10">
          <Reveal>
            <Pretitulo center={false}>{p.presentacion.pre}</Pretitulo>
            <h2 className="mt-4 font-serif text-3xl font-light tracking-tight text-ink md:text-5xl">{p.presentacion.titulo}</h2>
            <p className="mt-6 max-w-xl text-[15.5px] leading-relaxed text-ink-soft">{p.presentacion.cuerpo}</p>
          </Reveal>
        </div>
      </section>

      <section className="pb-20 md:pb-28" data-testid="f-categorias">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-6">
            {p.categorias.map((c, i) => {
              const hero = pick(c.hero[0], 0) || all(c.hero[0])[0];
              if (!hero) return null;
              return (
                <Reveal key={c.t} delay={(i % 3) * 0.07} testid={`f-categoria-${i}`}>
                  <Link to={`/${t.lang}/${c.to}`} className="img-frame group relative block aspect-[4/2.8] w-full" data-testid={`f-categoria-card-${i}`}>
                    <img src={hero} alt={c.t} loading="lazy" className="h-full w-full object-cover" />
                    <span className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/55 via-transparent to-transparent" />
                    <span className="absolute bottom-5 left-5 font-serif text-2xl text-sand">{c.t}</span>
                  </Link>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}